// frontend/src/components/IparcMark.js
// 1Parc chrome mark: twin parenthesis arcs with whisker ticks, ring, "1P".

let uid = 0;

export default function IparcMark({ size = 38, rounded = 8.5 }) {
  const gid = `iparcChrome${(uid += 1)}`;
  return (
    <div
      className="flex items-center justify-center shrink-0 bg-black"
      style={{
        width: size, height: size, borderRadius: rounded,
        boxShadow: '0 0 0 1px #2B2724, 0 4px 12px rgba(0,0,0,.55)',
      }}
    >
      <svg viewBox="0 0 200 200" width={size * 0.87} height={size * 0.87}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#F4F1EA" />
            <stop offset="0.45" stopColor="#C2BFB6" />
            <stop offset="0.55" stopColor="#8A8780" />
            <stop offset="1" stopColor="#E8E4DA" />
          </linearGradient>
        </defs>
        <g stroke={`url(#${gid})`} strokeWidth="2.6" strokeLinecap="round" fill="none">
          <path d="M72.95 41.99 A64 64 0 0 0 72.95 158.01" />
          <path d="M67.95 41.99h10M67.95 158.01h10" />
          <path d="M127.05 41.99 A64 64 0 0 1 127.05 158.01" />
          <path d="M122.05 41.99h10M122.05 158.01h10" />
          <circle cx="100" cy="100" r="42" />
        </g>
        <text x="100" y="101" textAnchor="middle" dominantBaseline="central"
              fontFamily="'Space Grotesk', system-ui, sans-serif" fontWeight="700"
              fontSize="38" letterSpacing="-1.5" fill={`url(#${gid})`}>1P</text>
      </svg>
    </div>
  );
}
